import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
function isIos() {
    if (!navigator.platform) {
        return false;
    }
    return /iPad|iPhone|iPod/.test(navigator.platform);
}
// iOS height hack because safari sucks
// this hack is absolutely terrible and brittle so if you have any better idea,
// you are welcome to replace it
export function useIosHeightHack() {
    const rootRef = useRef(null);
    const [isIosHeightHackNeeded, setIsIosHeightHackNeeded] = useState(false);
    const checkIfHackIsNeeded = (node)=>{
        if (!node || !isIos()) {
            return;
        }
        // if the menu's height is bigger than the screen size, despite being 100vh,
        // we add some extra padding to force it to scroll so it cant be covered
        // by the dumb toolbar
        const menuHeight = node.getBoundingClientRect().height;
        setIsIosHeightHackNeeded(menuHeight > window.innerHeight);
    };
    const setRootRef = (node)=>{
        rootRef.current = node;
        checkIfHackIsNeeded(node);
    };
    useEffect(()=>{
        if (!isIos()) {
            return;
        }
        const onScroll = throttle(()=>{
            checkIfHackIsNeeded(rootRef.current);
        }, 500);
        window.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>window.removeEventListener('scroll', onScroll);
    }, []);
    return {
        isIosHeightHackNeeded,
        setRootRef
    };
}

//# sourceMappingURL=useIosHeightHack.js.map